export default __webpack_public_path__ + "static/media/Account-sample.e2536de5.png";